import styled, { css, keyframes } from "styled-components";

export const Timer5Wrapper = styled.div`
  background: #080B1C;
  width: 1920px;
  height: 1080px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 66px;
  position: relative;

  > .background {
    background: #000000c4;
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
`;

export const Timer5Background = styled.div<{ backgroundImage: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ backgroundImage }) =>
    `url(${backgroundImage}) lightgray 50% / cover no-repeat`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: blur(2.5px);
  opacity: 0.4;
`;

export const Timer5Body = styled.div`
  position: relative;
  flex: 1;
  width: calc(100% - 30px);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Timer5Center = styled.div`
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;

  > .timer-wrapper {
    margin-top: 14px;
    width: 865px;
    height: 990px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    justify-content: flex-end;

    > img {
      z-index: -1000;
      position: absolute;
      opacity: 0.6;
    }

    > .dash-wrapper {
      position: absolute;
      top: 64px;
      left: 97px;
      width: 647px;
      height: 647px;
      > img {
        width: 952px;
        height: 952px;
      }
    }
  }
`;

export const Timer5Header = styled.div`
  width: calc(100% - 60px);
  position: relative;
  height: 98px;
  padding: 10px 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  > .pub-name {
    color: #fff;
    text-align: right;
    font-family: Pretendard;
    font-size: 35px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .tournament-info-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    > img {
      width: 80px;
      height: 80px;
      border-radius: 80px;
      object-fit: cover;
    }

    > .titleWrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      > .title {
        color: #fff;
        text-align: center;
        font-family: Pretendard;
        font-size: 45px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      > .type {
        color: #fff;
        text-align: center;
        font-family: Pretendard;
        font-size: 35px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;

        > span {
          font-weight: 500;
        }
      }
    }
  }
`;

export const Circle = styled.svg<{ break: boolean }>`
  position: absolute;
  z-index: -1;
  width: 800px;
  height: 800px;
  top: 120px;

  circle {
    fill: none;
    stroke-width: 40;
    stroke-linecap: round;
    filter: drop-shadow(
      0 0 15px ${({ break: isBreak }) => (!isBreak ? "#37F4FA" : "#A70205")}
    );
  }

  .progress {
    stroke: ${({ break: isBreak }) => (!isBreak ? "#37F4FA" : "#A70205")};
    stroke: url(#progressGradient);
    transition: stroke-dashoffset 0.35s;
    transform: scaleX(-1) scaleY(-1) rotate(-80deg);
    transform-origin: center;
  }
`;
export const Circle5 = styled(Circle)``;

export const Timer5Box = styled.div`
  z-index: 1;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > .level-break {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    gap: 10px;
    align-items: center;

    > img {
      width: 66px;
      height: auto;
    }

    > .next-break {
      height: 60px;
      color: #fff;
      text-align: center;
      font-size: 50px;
      font-weight: 700;

      > span {
        color: #fff;
        font-family: Pretendard;
        font-size: 45px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }

    > .now-level {
      height: 60px;
      color: #fff;
      text-align: center;
      font-size: 50px;
      font-weight: 700;
    }

    > .now-level.break {
      color: rgba(255, 0, 4, 0.7);
    }
  }

  > .time {
    text-align: center;
    color: #fff;
    text-align: center;
    font-size: 260px;
    font-weight: 900;
    font-size: 130px;
    font-variant-numeric: tabular-nums;
  }

  > .time.level {
    color: #fff;
  }

  > .bottom {
    margin-left: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;

    > .line {
      width: 2px;
      height: 61px;
      background: #fff;
    }

    > .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      > .title {
        color: #a5a5a5;
        text-align: center;
        font-family: Pretendard;
        font-size: 26.145px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      > .value {
        color: #fff;
        text-align: center;
        font-family: Pretendard;
        font-size: 43.575px;
        font-style: normal;
        font-weight: 900;
        line-height: normal;
      }

      > .value.break {
        color: #676767;
      }

      > .value2 {
        width: 240px;
        color: #fff;
        text-align: center;
        font-family: Pretendard;
        font-size: 50px;
        font-style: normal;
        font-weight: 900;
        line-height: normal;
      }

      > .value2.break {
        color: #676767;
      }
    }
  }
`;

export const Timer5blindWrapper = styled.div`
  margin-top: 15px;
`;

export const Timer5NowBlindWrapper = styled.div`
  width: 755px;
  height: 177px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  background:
    radial-gradient(
      67.86% 85.25% at 17.58% 4.3%,
      rgba(46, 167, 255, 0.5) 0%,
      #1c1b33 78.06%
    ),
    #080b1c;
  align-items: center;
  justify-content: center;
  border: 0.5px solid #17b9ff73;
  color: #fff;
  text-align: center;
  font-family: "Termina Test";
  box-sizing: border-box;

  > .title {
    font-size: 40px;
    font-weight: 500;
  }

  > .value {
    font-size: 50px;
    font-weight: 700;
  }
`;

export const Timer5NextBlindWrapper = styled.div`
  margin-top: 10px;
  width: 755px;
  height: 177px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  background:
    radial-gradient(
      69.9% 110.16% at 17.58% 4.3%,
      rgba(46, 167, 255, 0.2) 0%,
      rgba(28, 27, 51, 0.08) 78.06%
    ),
    #080b1c;
  align-items: center;
  justify-content: center;
  color: #b2c0d1;
  text-align: center;
  font-family: "Termina Test";
  box-sizing: border-box;

  > .title {
    font-size: 35px;
    font-weight: 500;
  }

  > .value {
    font-size: 45px;
    font-style: normal;
    font-weight: 700;
  }
`;

export const Timer5LeftWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Timer5LeftItemWrapper = styled.div<{ isRed: boolean }>`
  position: relative;
  width: 512px;
  padding-left: 30px;
  height: 160px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  justify-content: center;
  background: ${({ isRed }) =>
    isRed
      ? "radial-gradient(69.9% 110.16% at 17.58% 4.3%, rgba(255, 0, 4, 0.4) 0%, rgba(255, 4, 8, 0.16) 78.06%)"
      : "radial-gradient(69.9% 110.16% at 17.58% 4.3%, rgba(76, 39, 139, 0.8) 0%, rgba(28, 27, 51, 0.2) 78.06%)"};
  > .title {
    color: #fff;
    font-family: "Termina Test";
    font-size: 25px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > .value {
    color: #fff;
    font-family: "Termina Test";
    font-size: 45px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const Timer5RightWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  padding: 30px;
  padding-bottom: 0;
  box-sizing: border-box;
  background: radial-gradient(
    69.9% 110.16% at 17.58% 4.3%,
    rgba(76, 39, 139, 0.8) 0%,
    rgba(28, 27, 51, 0.2) 78.06%
  );
  width: 512px;
  height: 880px;
  align-items: flex-end;
  justify-content: space-between;
  border: 1px solid #17b9ff1a;
  gap: 10px;

  > .prize-wrapper {
    margin-top: 10px;
    margin-right: 2px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  .title {
    font-size: 30px;
    font-weight: 700;
    line-height: 30px;
    text-align: right;
    color: white;
    margin-bottom: 20px;
  }
`;

export const Timer5Notice = styled.div`
  position: relative;
  color: #fff;
  font-size: 20px;
  font-weight: 500;
  width: 452px;
  height: 115px; /* 고정 높이 */
  padding: 10px;
  border-radius: 16px;
  box-sizing: border-box;
  line-height: 1.1; /* 줄 간격 설정 */
  text-overflow: ellipsis; /* 초과된 부분에 "..." 표시 */
  overflow-wrap: break-word;
  overflow: hidden; /* 내용이 넘치면 잘림 */
  display: -webkit-box; /* 웹킷 박스 모델로 설정 */
  -webkit-line-clamp: 4; /* 5줄로 제한 */
  -webkit-box-orient: vertical; /* 블록 방향 설정 */
  background: radial-gradient(
    69.9% 110.16% at 17.58% 4.3%,
    rgba(255, 0, 4, 0.4) 0%,
    rgba(255, 4, 8, 0.16) 78.06%
  );
`;

const slideAnimation = keyframes`
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  15% {
    transform: translateY(0);
    opacity: 1;
  }
  85% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-30%);
    opacity: 0;
  }
`;

export const Timer5PrizeItem = styled.div<{
  length: number;
  subPrizeFont: number;
}>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  justify-content: flex-end;
  ${({ length }) =>
    length >= 11 &&
    css`
      animation: ${slideAnimation} 9s linear infinite;
    `}

  > .rank {
    width: 84px;
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: left;
  }

  .box {
    width: 358px;
    height: 60px;
    padding: 10px 15px;
    box-sizing: border-box;
    border-radius: 10px;
    color: #fff;
    text-align: right;
    font-family: Pretendard;
    font-size: 23px;
    font-style: normal;
    font-weight: 700;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    overflow: hidden; /* 넘치는 텍스트 숨김 */
    text-overflow: ellipsis; /* 넘칠 경우 말줄임 표시 */
    white-space: normal; /* 줄바꿈 허용 */
    overflow-wrap: break-word;
    font-variant-numeric: tabular-nums;

    > span {
      margin-right: 15px;
      font-size: 55px;
      letter-spacing: 1px;
    }
  }

  .sub {
    border-radius: 10px;
    padding: 8.5px 15px;
    background: #002f68;
    font-family: Pretendard;
    font-weight: 700;
    font-style: Bold;
    font-size: ${({ subPrizeFont }) => (subPrizeFont ? subPrizeFont : 16)}px;
    line-height: 100%;
    text-align: center;
    color: #fff;
    margin-left: 15px;
  }
`;

export const Timer5PrizeItemTop3 = styled.div<{ subPrizeFont: number }>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  justify-content: flex-end;

  > .rank {
    width: 84px;
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: left;
  }

  .box {
    width: 358px;
    height: 60px;
    padding: 10px 15px;
    box-sizing: border-box;
    border-radius: 10px;
    color: #fff;
    text-align: right;
    font-family: Pretendard;
    font-size: 23px;
    font-style: normal;
    font-weight: 700;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    overflow: hidden; /* 넘치는 텍스트 숨김 */
    text-overflow: ellipsis; /* 넘칠 경우 말줄임 표시 */
    white-space: normal; /* 줄바꿈 허용 */
    overflow-wrap: break-word;
    font-variant-numeric: tabular-nums;

    > span {
      margin-right: 15px;
      font-size: 55px;
      letter-spacing: 1px;
    }
  }

  .sub {
    border-radius: 10px;
    padding: 8.5px 15px;
    background: #002f68;
    font-family: Pretendard;
    font-weight: 700;
    font-style: Bold;
    font-size: ${({ subPrizeFont }) => (subPrizeFont ? subPrizeFont : 16)}px;
    line-height: 100%;
    text-align: center;
    color: #fff;
    margin-left: 15px;
  }
`;
